import { render, staticRenderFns } from "./indexBottom.vue?vue&type=template&id=0fdaf34a&scoped=true&"
import script from "./indexBottom.vue?vue&type=script&lang=js&"
export * from "./indexBottom.vue?vue&type=script&lang=js&"
import style0 from "./indexBottom.vue?vue&type=style&index=0&id=0fdaf34a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdaf34a",
  null
  
)

export default component.exports